export default [
  {
    path: '/statements',
    name: 'statements',
    meta: {
      access: 'statementView'
    },
    component: () => import('@/views/Statement/Table')
  },
  {
    path: '/client-statements-certificate',
    name: 'client-statements-certificate',
    meta: {
      access: 'clientStatementView'
    },
    component: () => import('@/views/Statement/Client/Table')
  },
  {
    path: '/statement/create',
    name: 'create-statement',
    meta: {
      access: 'statementCreate'
    },
    component: () => import('@/views/Statement/Form')
  },
  {
    path: '/statement/:id',
    name: 'statement-info',
    meta: {
      access: 'statementView'
    },
    component: () => import('@/views/Statement/Info')
  }
  , {
    path: '/client-statements-certificate/:id',
    name: 'client-statements-certificate-info',
    meta: {
      access: 'clientStatementView'
    },
    component: () => import('@/views/Statement/Client/Info')
  },
  {
    path: '/statement/:id/inspection/create',
    name: 'statement-create-inspection',
    meta: {
      access: 'inspectionCreate'
    },
    component: () => import('@/views/Inspection/Form')
  },
  {
    path: '/statement/:id/inspection/:inspectionID',
    name: 'statement-info-inspection',
    meta: {
      access: 'inspectionCard'
    },
    component: () => import('@/views/Inspection/Info')
  }
]
